import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { getFactories, messageFor, postStart, type ProductionDetail, type ProductionRow } from "../api";
import { todayFor } from "../format";

export function StartDialog({ row, open, onOpenChange, onSuccess }: { row: ProductionRow; open: boolean; onOpenChange: (open: boolean) => void; onSuccess: (detail: ProductionDetail) => void }) {
  const [date, setDate] = useState(() => todayFor(row.entity_id));
  const [factory, setFactory] = useState(row.factory_id ?? "");
  const [error, setError] = useState<unknown>(null);
  const [saving, setSaving] = useState(false);
  const factories = useQuery({ queryKey: ["pcogs", "factories", row.entity_id], queryFn: () => getFactories(row.entity_id), enabled: open && row.path === "A" });
  const submit = async () => {
    if (!date || (row.path === "A" && !factory)) return;
    setSaving(true); setError(null);
    try {
      const result = await postStart(row.production_key, { production_date: date, ...(row.path === "A" ? { factory_id: factory } : {}) });
      onSuccess(result.data); onOpenChange(false);
    } catch (caught) { setError(caught); }
    finally { setSaving(false); }
  };
  return <Dialog open={open} onOpenChange={onOpenChange}><DialogContent>
    <DialogHeader><DialogTitle>Start {row.production_key}</DialogTitle><DialogDescription>Starting moves this production to Draft and pins the current BOM version to each SKU.</DialogDescription></DialogHeader>
    {Boolean(error) && <Alert variant="destructive"><AlertDescription>{messageFor(error)}</AlertDescription></Alert>}
    <div className="space-y-1.5"><Label htmlFor="pcogs-start-date">Production date</Label><Input id="pcogs-start-date" type="date" value={date} onChange={(event) => setDate(event.target.value)} /></div>
    {row.path === "A" && <div className="space-y-1.5"><Label>Factory</Label><Select value={factory} onValueChange={setFactory}><SelectTrigger className="w-full"><SelectValue placeholder="Choose a factory" /></SelectTrigger><SelectContent>{(factories.data?.data ?? []).map((item) => <SelectItem key={item.factory_id} value={item.factory_id}>{item.name}</SelectItem>)}</SelectContent></Select></div>}
    <DialogFooter><Button disabled={saving || !date || (row.path === "A" && !factory)} onClick={() => void submit()}>Start production</Button></DialogFooter>
  </DialogContent></Dialog>;
}
